import axios from 'axios';

const createInteraction = (data) => {
  const idata = oa.actions.createInteraction(data).then(
    data => data,
    () => {
      console.log('error');
      return null;
    },
  );
  return idata;
};

const createLeadForInteraction = (data, interactionKey) => {
  const ldata = oa.actions.createLeadForInteraction(data, interactionKey).then(
    data => data,
    () => {
      console.log('error');
      return null;
    },
  );
  return ldata;
};

const updateLead = (leadKey, data) => {
  const upldata = oa.lead.updateLead(leadKey, data).then(
    data => data,
    () => {
      console.log('error');
      return null;
    },
  );
  return upldata;
};

export default {
  createInteraction,
  createLeadForInteraction,
  updateLead,
};
